import {IHttpService} from "angular";
import {IsoDateTime} from "../../pseudo-types/DateTypes";
import {CodeAndExchange} from "app/instruments/types/CodeAndExchange";

export type Sales = ReadonlyArray<Sale>;

export interface Sale {
    readonly tradeNumber: number;
    readonly tradeDateTime: IsoDateTime;
    readonly price: number;
    readonly volume: number;
    readonly value: number;
}

export class CourseOfSalesService {
    public static id = "courseOfSalesService";

    /** @ngInject */
    public constructor(private readonly $http: IHttpService) {
    }

    public async courseOfSales(security: CodeAndExchange): Promise<Sales> {
        const code = security.code;
        const response = await this.$http.get<ReadonlyArray<Sale>>(`/tradefloor/api/course-of-sales/${code}`);

        return response.data!;
    }
}
